import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-pill-bar',
	templateUrl: './pill-bar.component.html',
	styleUrls: ['./pill-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class PillBarComponent {
	@Input() items: string[];

	@Output() selected = new EventEmitter();

	@Input() endCaps = false;

	// On small screens, collapse to the selected item with an "of N" total (e.g. for pagination)
	@Input() compact = false;

	@Input() customStyle;

	public selectedItem: string;

	constructor() {
	}

	@Input() set default(value: string) {
		this.selectedItem = value;
	}

	select(item) {
		this.selectedItem = item;
		this.selected.emit(item);
	}

	next() {
		const currentIndex = this.items.indexOf(this.selectedItem);
		if (currentIndex === this.items.length - 1) return;
		this.selectedItem = this.items[currentIndex + 1];
		this.selected.emit(this.selectedItem);
	}

	previous() {
		const currentIndex = this.items.indexOf(this.selectedItem);
		if (currentIndex === 0) return;
		this.selectedItem = this.items[currentIndex - 1];
		this.selected.emit(this.selectedItem);
	}
}
